import { NgModule } from '@angular/core';
import { BrandLogoComponent } from './brand-logo.component';

// Own module so the nav shell can use the logo without importing ThemeModule
// (ThemeModule already imports NavShellModule — that would close a cycle).
@NgModule({
  declarations: [BrandLogoComponent],
  exports: [BrandLogoComponent],
})
export class BrandLogoModule {}
